

define(['angular', 'squid/index', './directive'], function (angular, squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    angular.module('xo-onetouch-upsell.route', ['squid', 'xo-onetouch-upsell.directive']).factory('$OneTouchUpsellRoute', function ($ComponentRoute) {

        return $ComponentRoute.extend('OneTouchUpsellRoute', {

            name: 'oneTouchUpsell',
            directive: 'xo-onetouch-upsell',
            trackingData: {
                fptiState: 'onetouch-upsell',
                buzname: {
                    'fullpage': {
                        'pagename': '%::onetouch-upsell',
                        'pagename2': '%::onetouch-upsell:member:hermes:',
                        'version': 'member:%:'
                    }
                }
            },
            query: ['oneTouchFlowName'],
            children: []
        });
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/onetouch-interstitial/route.js
// module id = ./components/xo-login-components/src/onetouch-interstitial/route.js
// module chunks = 1